import React, { createContext, useContext, useState, useEffect } from "react";
import AuthService from "services/auth-service";

const UserContext = createContext();

export function UserProvider({ children }) {
  const initialUserData = {
    name: "",
    phone: "",
    email: "",
    idNumber: "",
    role: "",
    profile_image: "",
    active: "",
  };

  const [userData, setUserData] = useState(initialUserData);

  const getUserData = async () => {
    try {
      const response = await AuthService.getProfile();
      setUserData((prevUser) => ({
        ...prevUser,
        ...response.data.attributes,
      }));
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  const resetUserData = () => {
    setUserData(initialUserData); // Reset to initial state when user logs out
  };

  const token = localStorage.getItem("token");

  // useEffect(() => {
  //   getUserData();
  // }, [token]);

  return (
    <UserContext.Provider value={{ userData, resetUserData }}>
      {children}
    </UserContext.Provider>
  );
}

export function useUser() {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error("useUser must be used within a UserProvider");
  }
  return context.userData;
}

export function useResetUserData() {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error("useResetUserData must be used within a UserProvider");
  }
  return context.resetUserData;
}
